import { WorkBook, WorkSheet } from 'xlsx';
import { ExcelWorksheet } from '../models/ExcelWorksheet';

export function createWorkbook(props: { orderedSheets: ExcelWorksheet[] }): WorkBook {
  const { orderedSheets } = props;

  return {
    SheetNames: orderedSheets.map(({ name }: ExcelWorksheet) => name),

    Sheets: orderedSheets.reduce((acc: { [sheet: string]: WorkSheet }, { name, sheet }: ExcelWorksheet) => {
      if (name in acc) {
        throw new Error(
          `"${name}" is registered as sheet name more than once. Cannot have multiple sheets with the same name.`,
        );
      }

      acc[name] = sheet;

      return acc;
    }, {}),
  };
}
